import { z } from "zod";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { ChartOfAccountsTemplateVariableKind } from "@common/constants/domains/accounting/chartOfAccountsTemplateAccount";
import { AccountRole } from "@common/types/domains/accounting/account";
import { form1099BoxSchema } from "@common/schemas/domains/accounting/account.schema";

export const ChartOfAccountsTemplateAccountGroupSchema = z.object({
    id: z.string().uuid(),
    templateId: z.string().uuid(),
    name: z.string(),
    type: z.nativeEnum(AccountType),
    parentGroupId: z.string().uuid().nullable(),
    sortOrder: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type ChartOfAccountsTemplateAccountGroup = z.infer<
    typeof ChartOfAccountsTemplateAccountGroupSchema
>;

export const ChartOfAccountsTemplateAccountSchema = z.object({
    id: z.string().uuid(),
    templateId: z.string().uuid(),
    code: z.number().nullable(),
    codeText: z.string().nullable(),
    kickOriginalCode: z.number().nullable(),
    name: z.string(),
    type: z.nativeEnum(AccountType),
    isDisabled: z.boolean(),
    isManuallyCreated: z.boolean(),
    role: z.nativeEnum(AccountRole).nullable(),
    variableKind: z.nativeEnum(ChartOfAccountsTemplateVariableKind).nullable(),
    form1099Box: form1099BoxSchema,
    parentGroupId: z.string().uuid().nullable(),
    sortOrder: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type ChartOfAccountsTemplateAccount = z.infer<
    typeof ChartOfAccountsTemplateAccountSchema
>;
